import { observer } from 'mobx-react-lite'
import { Dialog } from 'components/dialogs/Dialog'
import { DialogCloseButton } from 'components/dialogs/DialogCloseButton'
import { BreakoutButton } from 'components/design-system/BreakoutButton'
import { PeerReviewGrid } from 'components/PeerReview/PeerReviewGrid'
import { useDialogs } from 'hooks/dialogs'
import { useTranslationTyped } from 'i18n/i18n'
import type { StudentPeerReviewController } from '@breakoutlearning/firebase-repository/cubits/StudentAssignment/StudentPeerReviewController'
import { SpinnerCentered } from 'components/Spinner'
import { useId } from 'react'

export const PeerReviewViewDialog = observer(function PeerReviewViewDialog({
  controller,
  assignmentTitle,
}: {
  controller: StudentPeerReviewController
  assignmentTitle: string
}) {
  const { tt } = useTranslationTyped()
  const { popDialog } = useDialogs()
  const headingId = useId()

  const peerReviewQuestions = controller.peerReviewQuestions
  const revieweesState = controller.reviewees

  if (peerReviewQuestions.isLoading || revieweesState.isLoading) {
    return <SpinnerCentered />
  }

  const peerReviewQuestionsValue = peerReviewQuestions.models
  const reviewees = revieweesState.value

  return (
    <Dialog
      aria-labelledby={headingId}
      size="lg"
      dismissOnEscapeKey
      className="flex flex-col"
      innerClassName="flex flex-col gap-8 p-13"
    >
      <DialogCloseButton />
      <div className="flex flex-col gap-3">
        <h2
          id={headingId}
          className="text-center text-headline-large text-on-surface"
        >
          {tt.student_assignment.your_peer_reviews_for({
            title: assignmentTitle,
          })}
        </h2>
      </div>

      {reviewees && reviewees.length > 0 && (
        <PeerReviewGrid
          peerReviewQuestions={peerReviewQuestionsValue}
          reviewees={reviewees}
          readOnly={true}
        />
      )}

      <div className="flex items-center justify-center">
        <BreakoutButton kind="accent" onClick={() => popDialog()}>
          {tt.instructor_assignment.close()}
        </BreakoutButton>
      </div>
    </Dialog>
  )
})
